import Autoplay from "embla-carousel-autoplay";
import useEmblaCarousel from "embla-carousel-react";
import { Children, type ReactNode } from "react";

import { NewCarousel } from "../NewCarousel";

import { BarNavigation } from "./BarNavigation";

interface Props {
  children: ReactNode;
}

const InformationCarousel = ({ children }: Props) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ align: "start", loop: true }, [Autoplay()]);

  const maxSlides = () => {
    const allSlideItems = Children.toArray(children);

    return allSlideItems.slice(0, 5);
  };

  return (
    <section>
      <NewCarousel.SlideContainer
        emblaRef={emblaRef}
        emblaApi={emblaApi}
        isLooping
        isFullWidth
        type="information"
      >
        {maxSlides()}
      </NewCarousel.SlideContainer>
      <InformationCarousel.BarNavigation emblaApi={emblaApi} />
    </section>
  );
};

InformationCarousel.BarNavigation = BarNavigation;

export { InformationCarousel };
